import { render, staticRenderFns } from "./Healthymind.vue?vue&type=template&id=45a2e516&scoped=true&"
import script from "./Healthymind.vue?vue&type=script&lang=js&"
export * from "./Healthymind.vue?vue&type=script&lang=js&"
import style0 from "./Healthymind.vue?vue&type=style&index=0&id=45a2e516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a2e516",
  null
  
)

export default component.exports